<template>
  <div>
    <ui-dialog :show="isOpen" max-width="542" @input="handleClose">
      <template #header>
        <h3>
          {{ $t("message.notes.note") }}
        </h3>
      </template>
      <p>{{ $t("message.notes.deleteNoteDescription") }}</p>
      <template #actions>
        <div class="w-100 d-flex justify-space-between">
          <ui-button color="primary" outlined @click="handleClose">
            {{ $t("message.common.cancel") }}
          </ui-button>
          <ui-button
            outlined
            color="pink"
            icon-color="red"
            icon="icon-trash"
            @click="handleDelete"
          >
            {{ $t("message.notes.deleteNote") }}
          </ui-button>
        </div>
      </template>
    </ui-dialog>
  </div>
</template>

<script>
export default {
  name: "DeleteNoteDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    note: {
      type: String
    }
  },

  data() {
    return {
      noteText: null
    };
  },

  created() {
    this.noteText = this.note;
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleDelete() {
      this.$emit("delete");
    }
  }
};
</script>
